<template>
  <DialogComponent
    :hashBase="this.hashBase"
    ref="dialog"
    v-slot="{ data: { dialogIsVisible } }"
  >
    <div
      class="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      :class="{
        'pointer-events-all': dialogIsVisible,
        'pointer-events-none [&_*]:!pointer-events-none': !dialogIsVisible,
      }"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-30 transition-opacity dialogOverlay"
        :class="{
          'ease-out duration-100 opacity-100 ': dialogIsVisible,
          'ease-in duration-100 opacity-0 pointer-events-none':
            !dialogIsVisible,
        }"
      ></div>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <div
            class="absolute w-full h-full"
            @click="
              () => {
                if (onOverlayClick) onOverlayClick()
                else if (overlayerCanDismiss) hide()
              }
            "
          ></div>

          <div
            :class="{
              'ease-out duration-300 opacity-100 top-0 ': dialogIsVisible,
              'ease-in duration-200 opacity-0 top-4 sm:top-0 pointer-events-none dialogNotVisible scale-[0.8]':
                !dialogIsVisible,
            }"
            class="boxComponent relative overflow-hidden text-left transition-all sm:my-8 max-w-[90%] sm:w-[max-content] inline-block"
          >
            <div class="boxComponent bg-[#FBFBFC] absolute w-full h-full z-[0]"></div>

            <div class="w-full h-full relative">
              <div
                class="pb-4 pt-5 sm:p-6 sm:pb-4"
                v-if="dialogIsVisible || keepContentAlive"
              >
                <div class="sm:flex sm:items-start">
                  <div
                    v-if="!!$slots.icon && iconLeftBg"
                    :style="{ 'background-color': iconLeftBg }"
                    class="px-4 mx-auto flex flex-shrink-0 items-center justify-center rounded-full sm:mx-0"
                  >
                    <div class="p-2">
                      <slot name="icon"> </slot>
                    </div>
                  </div>
                  <div
                    class="sm:text-left"
                    :class="{
                      'mt-3 sm:ml-4 sm:mt-0': $slots.icon && iconLeftBg,
                    }"
                  >
                    <slot name="header">
                      <slot name="titleContainer">
                        <span
                          class="px-4 text-3xl md:text-2xl block font-bold title-color"
                          ><slot name="titleText"></slot
                        ></span>
                      </slot>
                      <div class="py-2"></div>
                      <slot name="subtitleContainer">
                        <span
                          class="textComponent px-4  block description-color"
                          ><slot name="subtitleText"></slot
                        ></span>
                      </slot>
                      <slot name="banner"> </slot>
                      <div class="py-4"></div>
                    </slot>
                    <slot name="fullContent">
                      <div class="mt-2 max-h-[80dvh] overflow-auto">
                        <div class="px-4">
                          <slot></slot>
                        </div>
                      </div>
                    </slot>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  dialogIsVisible &&
                  (!!$slots.primaryButton || !!$slots.cancelButton)
                "
                class="px-4 py-3 flex sm:px-6 gap-3"
                :class="{ 'flex-row-reverse': buttonsToRight }"
              >
                <button
                  class="p-4 ripple"
                  v-if="!!$slots.primaryButton"
                  @click="
                    () => {
                      onPrimaryClick()
                    }
                  "
                  :loading="primaryButtonLoading"
                >
                  <span class="title-color">
                    <slot name="primaryButton"></slot>
                  </span>
                </button>
                <button
                  class="p-4 ripple"
                  v-if="!!$slots.cancelButton"
                  @click="
                    () => {
                      if (onCancelClick) onCancelClick()
                      else hide()
                    }
                  "
                >
                  <span class="title-color">
                    <slot name="cancelButton"></slot>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue'
import DialogComponent from './DialogComponent.vue'

export default defineComponent({
  name: 'FeesComponent',
  components: { DialogComponent },
  props: {
    init: {
      type: Function,
      default: (show, hide, isVisible) => {},
    },
    onPrimaryClick: {
      type: Function,
      default: () => {},
    },
    onOverlayClick: {
      type: Function,
      default: null,
    },
    onCancelClick: {
      type: Function,
      default: null,
    },
    onBackButtonClick: {
      type: Function,
      default: null,
    },
    iconLeftBg: {
      type: String,
      default: 'red',
    },
    overlayerCanDismiss: {
      type: Boolean,
      default: true,
    },
    buttonsToRight: {
      type: Boolean,
      default: true,
    },
    primaryButtonLoading: {
      type: Boolean,
      default: false,
    },
    keepContentAlive: {
      type: Boolean,
      default: false,
    },
    hashBase: {
      type: String,
      default: 'modalvisible',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    show() {
      this.$refs.dialog.show()
    },
    hide() {
      this.$refs.dialog.hide()
    },
    isVisible() {
      return this.$refs.dialog.isVisible()
    },
  },
})
</script>
